var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuickView = function SvgQuickView(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2584_54657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99909 5.93379C5.84 5.93379 3.84759 7.354 2.49586 8.64796C1.74461 9.3671 1.74461 10.6338 2.49586 11.353C3.84759 12.6469 5.84 14.0671 7.99909 14.0671C10.1582 14.0671 12.1506 12.6469 13.5023 11.353C14.2536 10.6338 14.2536 9.3671 13.5023 8.64796C12.1506 7.354 10.1582 5.93379 7.99909 5.93379ZM1.66606 7.78111C3.06607 6.44093 5.35258 4.73379 7.99909 4.73379C10.6456 4.73379 12.9321 6.44093 14.3321 7.78111C15.577 8.97275 15.577 11.0282 14.3321 12.2198C12.9321 13.56 10.6456 15.2671 7.99909 15.2671C5.35258 15.2671 3.06607 13.56 1.66606 12.2198C0.42121 11.0282 0.421209 8.97275 1.66606 7.78111Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99844 8.96406C7.42587 8.96406 6.96172 9.42822 6.96172 10.0008C6.96172 10.5733 7.42587 11.0375 7.99844 11.0375C8.571 11.0375 9.03516 10.5733 9.03516 10.0008C9.03516 9.42822 8.571 8.96406 7.99844 8.96406ZM5.76172 10.0008C5.76172 8.76548 6.76313 7.76406 7.99844 7.76406C9.23374 7.76406 10.2352 8.76548 10.2352 10.0008C10.2352 11.2361 9.23374 12.2375 7.99844 12.2375C6.76313 12.2375 5.76172 11.2361 5.76172 10.0008Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.400391C8.33137 0.400391 8.6 0.66902 8.6 1.00039V2.50039C8.6 2.83176 8.33137 3.10039 8 3.10039C7.66863 3.10039 7.4 2.83176 7.4 2.50039V1.00039C7.4 0.66902 7.66863 0.400391 8 0.400391Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4243 2.57613C14.6586 2.81044 14.6586 3.19034 14.4243 3.42465L13.4243 4.42465C13.1899 4.65897 12.8101 4.65897 12.5757 4.42465C12.3414 4.19034 12.3414 3.81044 12.5757 3.57613L13.5757 2.57613C13.8101 2.34181 14.1899 2.34181 14.4243 2.57613Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.57574 2.57613C1.34142 2.81044 1.34142 3.19034 1.57574 3.42465L2.57574 4.42465C2.81005 4.65897 3.18995 4.65897 3.42426 4.42465C3.65858 4.19034 3.65858 3.81044 3.42426 3.57613L2.42426 2.57613C2.18995 2.34181 1.81005 2.34181 1.57574 2.57613Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2584_54657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuickView);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "quick-view.f088817e50f753d3172b85b51cd80643.svg";